import { render } from "./UserChangeDialog.vue?vue&type=template&id=23c52d6e&scoped=true"
import script from "./UserChangeDialog.vue?vue&type=script&lang=ts"
export * from "./UserChangeDialog.vue?vue&type=script&lang=ts"

import "./UserChangeDialog.vue?vue&type=style&index=0&id=23c52d6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23c52d6e"

export default script